export const OBJECT_ID_TIMESTAMP_DELIMITER = '||';
